import React from 'react';
import Header from './WorksComponents/Header';
import Navbar from './LandingComponents/Navbar';

function Works() {
  return (
    <>
      <Navbar />
      <Header />
    </>
  );
}

export default Works;
